
import React from 'react';
import './Redes.css';

function Redes() {
  const whatsappMessage = encodeURIComponent('Hola, estoy interesado en tus servicios, me puedes dar más información');
  const whatsappNumber = '525522632166';

  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/procam360mx',
      icon: 'fab fa-facebook',
      color: '#1877F2',
      gradient: 'linear-gradient(135deg, #1877F2, #4267B2)'
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/procam360mx',
      icon: 'fab fa-instagram',
      color: '#E4405F',
      gradient: 'linear-gradient(135deg, #833AB4, #FD1D1D, #FCAF45)'
    },
    {
      name: 'TikTok',
      url: 'https://www.tiktok.com/@procam360mx',
      icon: 'fab fa-tiktok',
      color: '#000000',
      gradient: 'linear-gradient(135deg, #00f2ea, #ff0050, #000000)'
    },
    {
      name: 'WhatsApp',
      url: `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`,
      icon: 'fab fa-whatsapp',
      color: '#25D366',
      gradient: 'linear-gradient(135deg, #25D366, #128C7E)'
    },
    {
      name: 'Cotizar Ahora',
      url: 'https://crm.procam360.mx/forms/cotizar',
      icon: 'fas fa-edit',
      color: '#eb6fbd',
      gradient: 'linear-gradient(135deg, #eb6fbd, #c95a9e)',
      isPrimary: true
    }
  ];

  return (
    <div className="redes-page">
      <div className="redes-container">
        <div className="redes-header">
          <img 
            src="/logos/logo_color_transparente.png" 
            alt="ProCam360" 
            className="redes-logo"
          />
          <h1>@ProCam360mx</h1>
          <p className="redes-subtitle">Tu opción en cabinas 360°</p>
          <p className="redes-description">
            Descubre los mejores momentos que hemos capturado en video 360°. 
            Cada evento es único, cada recuerdo es especial.
          </p>
        </div>

        <div className="redes-links">
          {socialLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`redes-link ${link.isPrimary ? 'redes-link-primary' : ''}`}
              style={{
                '--link-gradient': link.gradient,
                '--link-color': link.color
              }}
            >
              <i className={link.icon}></i>
              <span>{link.name}</span>
              <i className="fas fa-arrow-right"></i>
            </a>
          ))}
        </div>

        <footer className="redes-footer">
          <p>© 2024 ProCam360 - Todos los derechos reservados</p>
        </footer>
      </div>
    </div>
  );
}

export default Redes;
